import { baseRequest } from '../../utils/HttpClient';
import { ApiEndpoints } from '../../constants/ApiEndpoints';

export const getAppointments = (bodyRequest, queryParams) => {
  return baseRequest(ApiEndpoints.GET_APPOINTMENTS_V4, bodyRequest, null, queryParams);
};
export const downloadAppointments = (payload, requestBody) => {
  return baseRequest(ApiEndpoints.GET_APPOINTMENTS_V4, requestBody || {}, null, payload, true, true, true);
};
export const getAppointmentCptCodeById = id => {
  return baseRequest(ApiEndpoints.GET_APPOINTMENT_CPT_CODE_BY_ID, null, { id });
};

export const addAppointmentCptCode = bodyRequest => {
  return baseRequest(ApiEndpoints.ADD_APPOINTMENT_CPT_CODE, bodyRequest);
};

export const updateAppointmentCptCode = (bodyRequest, pathParams) => {
  return baseRequest(ApiEndpoints.UPDATE_APPOINTMENT_CPT_CODE, bodyRequest, pathParams);
};

export const fetchAMAState = pathParams => {
  return baseRequest(ApiEndpoints.FETCH_AMA_STATE, null, pathParams, null, true);
};

export const postAMA = bodyRequest => {
  return baseRequest(ApiEndpoints.POST_AMA, bodyRequest, null);
};

export const fetchSessionReportCard = pathParams => {
  return baseRequest(ApiEndpoints.FETCH_SESSION_REPORT_CARD, null, pathParams, null, true);
};

export const updatePatientSummary = (bodyRequest, pathParams) => {
  return baseRequest(ApiEndpoints.UPDATE_PATIENT_SUMMARY, bodyRequest, pathParams);
};

export const reSubmitClaim = (pathParams, queryParams) => {
  return baseRequest(ApiEndpoints.RESUBMIT_CLAIM, null, pathParams, queryParams);
};

export const sendMessage = (bodyRequest, queryParams) => {
  return baseRequest(ApiEndpoints.SEND_MESSAGE, bodyRequest, null, queryParams);
};

export const listMessage = queryParams => {
  return baseRequest(ApiEndpoints.LIST_MESSAGE, null, null, queryParams);
};

export const refreshMessage = queryParams => {
  return baseRequest(ApiEndpoints.REFRESH_MESSAGE, null, null, queryParams);
};

export const listFax = queryParams => {
  return baseRequest(ApiEndpoints.LIST_FAXES, null, null, queryParams);
};

export const getFaxById = jobId => {
  return baseRequest(ApiEndpoints.GET_FAX_BY_ID, null, { jobId }, null);
};

export const toggleFaxStatus = jobId => {
  return baseRequest(ApiEndpoints.TOGGLE_FAX_STATUS, null, { jobId }, null);
};

export const patientCaseConceptualizer = bodyRequest => {
  return baseRequest(ApiEndpoints.PATIENT_CASE_CONCEPTUALIZER, bodyRequest, null, null, true);
};

export const patientEngagementInsights = bodyRequest => {
  return baseRequest(ApiEndpoints.PATIENT_ENGAGEMENT_INSIGHTS, bodyRequest, null, null, true);
};

export const milestoneCelebrator = bodyRequest => {
  return baseRequest(ApiEndpoints.MILESTONE_CELEBRATOR, bodyRequest, null, null, true);
};

export const getRecommendationNotes = pathParams => {
  return baseRequest(ApiEndpoints.GET_RECOMMENDATION_NOTES, null, pathParams, null, true);
};

export const confirmRecommendationNotes = (bodyRequest, pathParams) => {
  return baseRequest(ApiEndpoints.CONFIRM_RECOMMENDATION_NOTES, bodyRequest, pathParams, null, true);
};

export const deleteRecommendationNotes = pathParams => {
  return baseRequest(ApiEndpoints.DELETE_RECOMMENDATION_NOTES, null, pathParams, null, true);
};

export const createInteractiveProblem = (appointmentId, payload) => {
  return baseRequest(ApiEndpoints.CREATE_INTERACTIVE_PROBLEM, payload, { appointmentId }, null);
};

export const getInteractiveGoals = payload => {
  return baseRequest(ApiEndpoints.GET_INTERACTIVE_GOALS, payload, null, null);
};

export const getInteractiveObjectives = payload => {
  return baseRequest(ApiEndpoints.GET_INTERACTIVE_OBJECTIVES, payload, null, null);
};

export const initializeLabAutomation = (pathparams, queryParams) => {
  return baseRequest(ApiEndpoints.INITIALIZE_LAB_AUTOMATION, null, pathparams, queryParams, true);
};

export const getDiagnosisRecommendations = pathparams => {
  return baseRequest(ApiEndpoints.GET_DIAGNOSIS_RECOMMENDATIONS, null, pathparams, null, true);
};

export const updateDiagnosisRecommendations = (bodyRequest, pathparams) => {
  return baseRequest(ApiEndpoints.UPDATE_DIAGNOSIS_RECOMMENDATIONS, bodyRequest, pathparams, null, true);
};
